var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.461 8.047"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.121 4.426a.39.39 0 0 1 0-.563L.684 3.3a.39.39 0 0 1 .563 0l.04.04L3.5 5.714a.194.194 0 0 0 .282 0L9.174.121h.04a.39.39 0 0 1 .563 0l.563.563a.39.39 0 0 1 0 .563L3.9 7.927a.39.39 0 0 1-.563 0L.2 4.547z"
})));
export default SvgIconTick;